import * as APITypes from '../../types/notificationHub.types';
type GeneratedSubscription<InputType, OutputType> = string & {
	__generatedSubscriptionInput: InputType;
	__generatedSubscriptionOutput: OutputType;
};

export const subscribeToNewNotifications =
	/* GraphQL */ `subscription SubscribeToNewNotifications(
  $userId: String
  $tenantId: String
  $product: String!
) {
  subscribeToNewNotifications(
    userId: $userId
    tenantId: $tenantId
    product: $product
  ) {
    userId
    tenantId
    product
    notificationBody
    __typename
  }
}
` as GeneratedSubscription<
		APITypes.SubscribeToNewNotificationsSubscriptionVariables,
		APITypes.SubscribeToNewNotificationsSubscription
	>;
export const addedNotification = /* GraphQL */ `subscription AddedNotification(
  $userId: String
  $tenantId: String
  $product: String
) {
  addedNotification(userId: $userId, tenantId: $tenantId, product: $product) {
    productId_tenantId_userId
    id
    product
    productId_tenantId
    tenantId
    userId
    timestamp
    createdAt
    receivedAt
    status
    metaData
    channels
    notificationType
    eventId
    expirationTimeStamp
    notificationText
    senderUserId
    severityLevel
    source
    __typename
  }
}
` as GeneratedSubscription<
	APITypes.AddedNotificationSubscriptionVariables,
	APITypes.AddedNotificationSubscription
>;
